module.exports = __webpack_public_path__ + "img/nounlock.cdd5d45b.png";